import emoji from 'emoji.json';

export default {
  install(Vue) {
    const emojitranslator = {
      translate(value) {
        if (!value || value.trim() === '') return '';

        let name = '';
        const matchingEmoji = emoji.find(e => e.char === value);

        if (matchingEmoji) {
          name = matchingEmoji.name;
        }

        return name;
      }
    };

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$emojitranslator = emojitranslator;
  }
};



// WEBPACK FOOTER //
// ./src/utils/emojitranslator.js